ixModuleRouting("impactx.productcoding", {
    "/prcodedummylist": {
        template: "<ixa-productcoding-dummy-list></ixa-productcoding-dummy-list>",
        templateUrl: "modules/productcoding/templates/prcodedummylist.html",
        controller: "ProductCodeDummyListCtrl",
        controllerAs: "productCodeDummyListCtrl",
        process: "ProductCodingDummy",
        workspace: "content",
    },
    "/prcodedummy/:id": {
        template: "<ixa-productcoding-dummy-view></ixa-productcoding-dummy-view>",
        templateUrl: "modules/productcoding/templates/prcodedummyview.html",
        controller: "ProductCodeDummyViewCtrl",
        controllerAs: "productCodeDummyViewCtrl",
        process: "ProductCodingDummy",
        workspace: "content",
    },
    "/productcoding/:newCatId?": {
        templateUrl: "modules/productcoding/templates/product-coding-tree.html",
        controller: "ProductCodingTreeCtrl",
        controllerAs: "productCodingTreeCtrl",
        process: "ProductCoding",
        workspace: "content",
    },
    '/productcodinglist/:comId/:vCatId/:prgId': {
        template: '<ixa-productcoding-list></ixa-productcoding-list>',
        templateUrl: 'modules/productcoding/templates/productcodinglist.html',
        controller: 'ProductCodingListCtrl',
        controllerAs: 'productCodingListCtrl',
        process: 'ProductCoding',
        workspace: 'content',
    },
});
